// Arabic descriptions for classification categories
export const AR_DESCRIPTIONS = {
  acier_brut: 'الفولاذ في شكل سبائك، قضبان، صفائح، لفائف',
  aluminium_brut: 'الألمنيوم بأشكاله الخام، قضبان، أسلاك',
  cuivre_brut: 'النحاس الخام، قضبان، أسلاك نحاسية',
  plastiques_granules: 'المواد البلاستيكية في شكل حبيبات، مسحوق، أشكال أولية',
  caoutchouc_brut: 'المطاط الطبيعي والاصطناعي الخام',
  produits_chimiques_base: 'المنتجات الكيميائية غير العضوية والعضوية الأساسية',
  bois_brut: 'الخشب الخام، الألواح، خشب النشر',
  papier_carton: 'الورق والكرتون',
  coton_brut: 'القطن الخام، غير مندوف ولا ممشط',
  zinc: 'الزنك الخام، غير مخلوط',
  plomb: 'الرصاص الخام',
  machines_industrielles: 'آلات التشغيل، مراكز التصنيع، المخارط، آلات التفريز',
  pompes_compresseurs: 'المضخات، الضواغط، المراوح',
  generateurs_moteurs: 'المحركات الكهربائية، المولدات',
  transformateurs_electriques: 'المحولات، المحولات العاكسة، الملفات',
  equipements_mesure: 'أدوات القياس الصناعية',
  materiel_informatique: 'الحواسيب، الخوادم، الأجهزة الطرفية',
  smartphones_tablettes: 'الهواتف المحمولة، الهواتف الذكية، الأجهزة اللوحية',
  climatisation: 'أجهزة التكييف، السبليت',
  chaudieres: 'المراجل البخارية',
  tracteurs: 'الجرارات الفلاحية',
  vehicules: 'السيارات، المركبات',
  panneaux_solaires: 'الألواح الشمسية الكهروضوئية',
  pieces_rechange_auto: 'قطع غيار وملحقات المركبات',
  roulements_paliers: 'المحامل الكروية، محامل الأسطوانات',
  joints_garnitures: 'حشوات الإحكام، الحلقات',
  composants_electroniques: 'المكثفات، المقاومات، الدوائر المتكاملة، أشباه الموصلات',
  cables_electriques: 'الأسلاك والكابلات الكهربائية المعزولة',
  pneus: 'الإطارات المطاطية الجديدة',
  batteries: 'المراكم، البطاريات',
  robinetterie: 'الحنفيات، الصمامات',
  ciment_platre: 'الإسمنت البورتلاندي، الجبس',
  carrelage_ceramique: 'بلاط السيراميك، القيشاني',
  tubes_tuyaux_acier: 'الأنابيب والمواسير من الفولاذ',
  peintures_vernis: 'الدهانات، الورنيش، اللكر',
  verre_plat: 'الزجاج المسطح، الزجاج المقسى',
  bois_contreplaque: 'الخشب الرقائقي، ألواح الخشب',
  sanitaire: 'الأجهزة الصحية من السيراميك',
  quincaillerie: 'الأقفال، المفصلات، المقابض',
  ble_cereales: 'القمح، الشعير، الذرة، السرغوم',
  sucre: 'سكر القصب أو البنجر الخام أو المكرر',
  huiles_vegetales: 'زيوت الصويا، الفول السوداني، الزيتون، عباد الشمس',
  viandes: 'اللحوم الطازجة، المبردة أو المجمدة',
  lait_produits_laitiers: 'الحليب، القشدة، الزبدة، الجبن',
  cafe_the: 'القهوة، الشاي',
  chocolat_confiserie: 'الشوكولاتة، الحلويات، الكاكاو',
  poissons: 'الأسماك المجمدة',
  fruits_legumes: 'الفواكه والخضروات الطازجة',
  epices: 'التوابل',
  conserves: 'المعلبات الغذائية',
  boissons: 'المشروبات غير الكحولية، العصائر',
  pates_alimentaires: 'المعكرونة، الكسكس',
  riz: 'الأرز',
  legumineuses: 'البقوليات الجافة',
  produits_pharmaceutiques: 'الأدوية، المنتجات الصيدلانية',
  dispositifs_medicaux: 'الأجهزة الطبية، الأدوات الجراحية',
  textiles_tissus: 'أقمشة القطن، الأقمشة الاصطناعية',
  vetements_confectionnes: 'الملابس الجاهزة',
  chaussures: 'الأحذية',
  electromenager: 'الأجهزة الكهرومنزلية',
  cosmetiques: 'العطور، مستحضرات التجميل',
  jouets: 'الألعاب، المقالات الرياضية',
  meubles: 'الأثاث',
  luminaires: 'أجهزة الإنارة',
  articles_menagers: 'الأدوات المنزلية من الفولاذ المقاوم للصدأ',
  detergents: 'المنظفات، مواد التنظيف',
  couches_hygiene: 'الحفاضات، الفوط الصحية',
  lunettes: 'النظارات الشمسية، الإطارات',
  montres: 'الساعات',
  bijoux: 'المجوهرات',
  sacs_bagages: 'الحقائب، الأمتعة',
  pesticides_phyto: 'المبيدات الحشرية، مبيدات الأعشاب',
  engrais: 'الأسمدة الآزوتية، الفوسفاتية، البوتاسية',
  semences: 'البذور',
  aliments_animaux: 'أعلاف الحيوانات',
  equipements_radio_telecom: 'معدات البث الإذاعي، الاتصالات',
  emballages_plastique: 'التغليف البلاستيكي',
  emballages_verre: 'القوارير والبرطمانات الزجاجية',
  fils_textiles: 'خيوط الألياف الاصطناعية',
  cuir: 'الجلود',
};
